<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-base">
        <vs-tabs>
          <vs-tab label="By Coa">
            <div class="tab-text">
              <index-by-coa></index-by-coa>
            </div>
          </vs-tab>
          <vs-tab label="By Detail COA">
            <div class="tab-text">
              <index-by-trx></index-by-trx>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </vx-card>
</template>
<script>
import IndexByCoa from './index-by-coa.vue';
import IndexByTrx from './index-by-trx.vue';
export default {
  components: {
    IndexByCoa,
    IndexByTrx
  },
  data() {
    return {

    };
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

.info-field-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #4a5568;
}

.info-field-input .vs-input--input {
  background-color: #f7fafc;
  border-color: #e2e8f0;
  color: #2d3748;
  font-weight: 500;
}

.info-field-input .vs-input--input:focus {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
}

.info-field-input .vs-input--icon {
  color: #718096;
}
</style>
